export default __webpack_public_path__ + "static/media/fontRoboto900_vietnamse.54e79593.woff2";